export default "__VITE_ASSET__CR9ciny2__"